import React from "react";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { styled } from "@mui/material";
import "./CreditCard.css";
import { selectFavCreditCard } from "../features/favCreditCard/favCreditCardSlice";
import { useSelector } from "react-redux";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor:
      theme.palette.grey[theme.palette.mode === "#008556" ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === "light" ? "#14B084" : "#008556",
  },
}));

const CreditCard = () => {
  const card = useSelector(selectFavCreditCard);
  const value = (card?.useOfBalance / card?.limitOfBalance) * 10000;
  const cardNumber = card?.cardNumber?.toString();
  const lastFourDigit = cardNumber?.slice(-4);

  // console.log(value);
  return (
    <div
      className="flex bg-white text-[#14B084] w-1/3 px-2 pb-5 pt-2 rounded-lg justify-center 
mr-4 flex-col"
    >
      <div className="flex justify-between mx-2">
        <h3 className="card__title font-semibold text-xl">
          Favourite Credit Card
        </h3>
        <button className="card__button bg-gradient-to-r from-[#008556] to-[#14B084] text-white text-center rounded-xl text-sm py-2 font-medium ml-auto px-2 italic">
          {card?.cardType}
        </button>
      </div>
      <h4 className="card__subheading text-gray-500 font-semibold text-[16px] mb-5 mx-2">
        XXXX XXXX XXXX {lastFourDigit}
      </h4>

      <h1 className="creditCard__heading font-semibold text-xl mb-1.5">
        Balance
      </h1>
      {/* <h1 className="card__number text-4xl mb-5">$ 338</h1> */}
      <BorderLinearProgress
        variant="determinate"
        value={value}
        className="creditcard__progressBar mb-4"
      />
      <div className="flex mb-4 justify-around mx-2">
        <div className="">
          <div className="creditCard__dot"></div>
          <div className="flex">spent</div>
        </div>
        <div className="">
          <div className="creditCard__dot1"></div>
          <div className="flex">available</div>
        </div>
      </div>
      <button className="card__button bg-gradient-to-r from-[#008556] to-[#14B084] text-white text-center rounded-2xl text-sm py-2 font-medium ml-auto px-4">
        Pay Now
      </button>
    </div>
  );
};

export default CreditCard;
